import React, { useState } from 'react';
import {
  TextField,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Card,
  CardContent,
  Button,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from '@mui/material';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import CustomTextField from '../../../../common/CustomTextField';
import { units } from '../../../../constants/units';
import { renderDropdownWithoutLabel } from '../../../../common/inputField';

const SpermPostwashFindings = ({ keyPath }) => {
  const dispatch = useDispatch();
  const spermPostwashFindings = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );

  const handleChange = (key, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
      if(key === 'volume' || key === 'spermCount'){
        const updatedVolume = (key === 'volume') ? value : spermPostwashFindings.volume || 0;
        const updatedSpermCount = (key === 'spermCount') ? value : spermPostwashFindings.spermCount || 0;
        dispatch(setAndrologyData(`${keyPath}.totalCount`, (updatedVolume * updatedSpermCount)));
      }
      if (
        key === 'progressive'
      ) {
        let updatedNonProgressive = '';
        const motilityValue = Number(spermPostwashFindings?.totalMotility )|| 0;
        if(motilityValue){
          updatedNonProgressive = motilityValue - Number(value);
          const updatedKey = 'nonProgressive';
          updatedNonProgressive = !value ? 0 : updatedNonProgressive
          dispatch(
            setAndrologyData(
              `${keyPath}.${updatedKey}`,
              updatedNonProgressive
            )
          );
        }
      }
      if(key === 'totalMotility' || key === 'totalMotility'){
        const updatedKey = 'immotile';
        const updatedValue = 100 - value
        dispatch(
          setAndrologyData(
            `${keyPath}.${updatedKey}`,
            updatedValue
          )
        )
      }
  };

  const handleDropdownChange = (e, index, name) => {
    const { value } = e.target;
    handleChange(name, value);
  };

  return (
    <Paper className="p-3 mb-3">
      <Typography variant="h6" gutterBottom>
        Sperm Postwash Findings
      </Typography>
      <TableContainer>
        <Table>
          <TableBody>
            {/* Postwash Sperm Analysis */}
            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Volume (ml)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPostwashFindings.volume}
                  onChange={(e) => handleChange('volume', e.target.value)}
                  fullWidth
                  suffix={units.spermAnalysis.volume} // Suffix for volume
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Sperm Washing Procedure
              </TableCell>
              <TableCell>
                {renderDropdownWithoutLabel(
                  'spermWashingProcedure',
                  spermPostwashFindings.spermWashingProcedure,
                  [
                    'Denisty Gradient',
                    'Swim Up',
                    'Density Gradient Followed By Swim Up',
                    'Microfluidics',
                  ],
                  handleDropdownChange,
                )}
              </TableCell>
            </TableRow>

            <TableRow>
            <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Sperm Count (M/ml)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPostwashFindings.spermCount}
                  onChange={(e) => handleChange('spermCount', e.target.value)}
                  fullWidth
                  suffix={units.spermAnalysis.spermCount} // Suffix for sperm count
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Total Count (M/Ejaculate)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  value={spermPostwashFindings.totalCount}
                  fullWidth
                  onChange={(e) => handleChange('totalCount', e.target.value)}
                  suffix={units.spermAnalysis.totalCount}
                />
              </TableCell>

            </TableRow>

            <TableRow>
            <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Total Motility (%)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPostwashFindings.totalMotility}
                  onChange={(e) =>
                    handleChange('totalMotility', e.target.value)
                  }
                  fullWidth
                  suffix={units.spermAnalysis.motility} // Suffix for total motility
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                a. Progressive (%)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  value={spermPostwashFindings.progressive}
                  fullWidth
                  onChange={(e) => handleChange('progressive', e.target.value)}
                  suffix={units.spermAnalysis.progression} // Suffix for progressive motility
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                b. Non-Progressive (%)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPostwashFindings.nonProgressive}
                  onChange={(e) =>
                    handleChange('nonProgressive', e.target.value)
                  }
                  fullWidth
                  suffix={units.spermAnalysis.nonProgression} // Suffix for non-progressive motility
                  InputProps={{ readOnly: true }}
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                c. Immotile (%)
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPostwashFindings.immotile}
                  onChange={(e) => handleChange('immotile', e.target.value)}
                  fullWidth
                  suffix={units.spermAnalysis.immotile} // Suffix for immotile percentage
                  InputProps={{ readOnly: true }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Total Motality Count
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={(spermPostwashFindings.volume * spermPostwashFindings.totalMotility * spermPostwashFindings.spermCount)/100}
                  onChange={(e) =>
                    handleChange('totalMotileCount', e.target.value)
                  }
                  fullWidth
                  suffix={units.spermAnalysis.totalMotileCount} 
                  InputProps = {{readOnly: true}}
                />
              </TableCell>
              
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SpermPostwashFindings;
